import { api } from "../client";
import { endpoints } from "../endpoints";

export const assignmentService = {
  list: (signal) => api.request({ url: endpoints.assignments.list, safeRead: true, signal }),
  detail: (id, signal) => api.request({ url: endpoints.assignments.detail(id), safeRead: true, signal }),
  upload(id, file, signal) {
    const data = new FormData();
    data.append("assignment_file", file);
    return api.request({ url: endpoints.assignments.upload(id), method: "POST", data, signal });
  },
};
